import { useApiSend } from '../../shared/api/utils/reactQueryProvider';
import { editRideDetails } from '../api/services/Rides';
import { EditRidePayload } from '../types/rides';

import { RIDE_DETAILS_QUERY_KEY } from './useRideDetailsQuery';
import { RIDE_OVERVIEW_QUERY_KEY } from './useRideOverviewQuery';

interface iUseEditRideSubmit {
  rideSlug: string;
  successCallback?: () => void;
  errorCallback?: (
    error:
      | Error & {
          errors: string[];
        }
  ) => void;
}

export const useEditRideSubmit = ({ rideSlug, successCallback, errorCallback }: iUseEditRideSubmit) => {
  return useApiSend(
    (payload: EditRidePayload) => editRideDetails(rideSlug, payload),
    successCallback,
    errorCallback,
    [RIDE_DETAILS_QUERY_KEY, RIDE_OVERVIEW_QUERY_KEY],
    undefined
  );
};
